import { Instance, types } from "mobx-state-tree";
import { ChatItemType } from "../ChatItemType";
import { TextChatItem } from "./TextChatItem";

/**
 * Generic notification with static text message and no need to support reactivity.
 */
export const NotificationChatItem = types.compose(
  TextChatItem,
  types.model({
    type: types.literal(ChatItemType.Notification)
  })
);

export interface INotificationChatItem extends Instance<typeof NotificationChatItem> {}
